import Sonda from '@gcloud-npm/utils.monitoring.sonda';
import getUUID from '@gcloud-npm/utils.monitoring.get-uuid';
import Request from '@gcloud-npm/utils.fetch';
import {
  TRADE_IN_HOST,
  GET_DEVICES_PAYLOAD,
  PROCESS_NAME,
} from './constants';

const PATH = `/model`;
const EVENT_NAME = 'TRADE_IN.MODEL';

const getDevices = ({
  search,
  id,
  deviceKind,
  context,
  build = false,
}) => {
  const idRequest = getUUID();
  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME,
  });
  const URL_API = `${TRADE_IN_HOST}${PATH}`;
  const fakeMethod = "POST";
  const payload = {
      ...GET_DEVICES_PAYLOAD,
      search: search || '',
      id: id || null,
  }
  // const headers2Use = calculateHeaderParams(build, FAMILY_API, context);
  const request = new Request({
    method: "GET",
    endpoint: `${URL_API}?method=${fakeMethod}&payload=${encodeURIComponent(JSON.stringify(payload))}`,
    headers: {
      withCredentials: true,
    },
    sonda,
  });
  return request.makeRequest();
};

export default getDevices;
